var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"product-details-title uk-h2 uk-text-bold uk-margin-remove uk-text-left"},[_vm._v(" "+_vm._s(_vm.name ?? _vm.fallback)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }